var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Pane, ThemeProvider } from "evergreen-ui";
import AddPlanCard from "../components/AddPlanCard";
import theme from "../theme";
import NavigatorBar from "../container/NavigatorBar";
export default function Upgrade() {
    return (_jsx(ThemeProvider, __assign({ value: theme }, { children: _jsxs(Pane, __assign({ style: {
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                background: "linear-gradient(#E4EBF5 0%, rgba(255,255,255,1) 100%)",
            } }, { children: [_jsx(NavigatorBar, {}), _jsx(AddPlanCard, { controls: false })] })) })));
}
